function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.83588 6.91558C8.61651 6.69621 8.25988 6.69508 8.03938 6.91446L6.18763 8.76733L5.46088 8.03946C5.24151 7.82008 4.88488 7.82008 4.66551 8.03946C4.44613 8.25883 4.44613 8.61546 4.66551 8.83483L5.79051 9.95983C5.89963 10.0701 6.04363 10.1252 6.18763 10.1252C6.33163 10.1252 6.47563 10.0701 6.58588 9.96096L8.83588 7.71096C9.05526 7.49158 9.05526 7.13496 8.83588 6.91558Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.83588 11.4156C8.61651 11.1962 8.25988 11.1951 8.03938 11.4145L6.18763 13.2673L5.46088 12.5406C5.24151 12.3212 4.88488 12.3212 4.66551 12.5406C4.44613 12.76 4.44613 13.1166 4.66551 13.336L5.79051 14.461C5.89963 14.5701 6.04363 14.6252 6.18763 14.6252C6.33163 14.6252 6.47563 14.5701 6.58588 14.461L8.83588 12.211C9.05526 11.9916 9.05526 11.635 8.83588 11.4156Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.9375 7.875H10.6875C10.377 7.875 10.125 8.127 10.125 8.4375C10.125 8.748 10.377 9 10.6875 9H12.9375C13.248 9 13.5 8.748 13.5 8.4375C13.5 8.127 13.248 7.875 12.9375 7.875Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.9375 12.375H10.6875C10.377 12.375 10.125 12.627 10.125 12.9375C10.125 13.248 10.377 13.5 10.6875 13.5H12.9375C13.248 13.5 13.5 13.248 13.5 12.9375C13.5 12.627 13.248 12.375 12.9375 12.375Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.625 2.25H12.375V1.6875C12.375 1.377 12.123 1.125 11.8125 1.125H10.5919C10.359 0.47025 9.7335 0 9 0C8.2665 0 7.641 0.47025 7.40812 1.125H6.1875C5.877 1.125 5.625 1.377 5.625 1.6875V2.25H3.375C2.75512 2.25 2.25 2.75513 2.25 3.375V16.875C2.25 17.4949 2.75512 18 3.375 18H14.625C15.2449 18 15.75 17.4949 15.75 16.875V3.375C15.75 2.75513 15.2449 2.25 14.625 2.25ZM6.75 2.25H7.875C8.1855 2.25 8.4375 1.998 8.4375 1.6875C8.4375 1.377 8.6895 1.125 9 1.125C9.3105 1.125 9.5625 1.377 9.5625 1.6875C9.5625 1.998 9.8145 2.25 10.125 2.25H11.25V3.375H6.75V2.25ZM14.625 16.875H3.375V3.375H5.625V3.9375C5.625 4.248 5.877 4.5 6.1875 4.5H11.8125C12.123 4.5 12.375 4.248 12.375 3.9375V3.375H14.625V16.875Z"
});

function SvgJobs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.28a03483.svg";
export { ForwardRef as ReactComponent };